module.exports = __webpack_public_path__ + "img/bgc.96df2d78.png";